import { SHOW_REGIONS_CITY_TYPE, SHOW_REGIONS_REGION_TYPE } from '../fields'
import {
  SHOW_OPTION_COUNTRIES,
  SHOW_OPTION_REGIONS,
  SHOW_OPTION_WORLDWIDE
} from '../../ReusableFormFields/GeolocationsFields/fields'

export const formatCountriesToBE = countries => {
  return {
    countries: countries.map(({ code }) => code)
  }
}
export const formatRegionsToBE = regions => {
  const filteredRegions = regions.filter(item => item.type === SHOW_REGIONS_REGION_TYPE)
  const filteredCities = regions.filter(item => item.type === SHOW_REGIONS_CITY_TYPE)

  return {
    regions: filteredRegions.map(({ value }) => ({
      key: value
    })),
    cities: filteredCities.map(({ value }) => ({
      key: value
    }))
  }
}
export const formatShowTargetToBE = ({ geotargetingOption, countries, regions }) => {
  switch (geotargetingOption) {
    case SHOW_OPTION_COUNTRIES:
      return formatCountriesToBE(countries)
    case SHOW_OPTION_REGIONS:
      return formatRegionsToBE(regions)
    case SHOW_OPTION_WORLDWIDE:
      return {
        country_groups: ['worldwide']
      }
    default:
      return {}
  }
}
